import saaf from './reducers/saaf';

export default {
    saaf: {
        reducer: saaf,
    },
};
